import _slicedToArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _DurationFormat_options;

var ListFormatPonyFill = /*#__PURE__*/function () {
  function ListFormatPonyFill() {
    _classCallCheck(this, ListFormatPonyFill);
  }

  _createClass(ListFormatPonyFill, [{
    key: "formatToParts",
    value: function formatToParts(members) {
      var parts = [];

      var _iterator = _createForOfIteratorHelper(members),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var value = _step.value;
          parts.push({
            type: 'element',
            value: value
          });
          parts.push({
            type: 'literal',
            value: ', '
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return parts.slice(0, -1);
    }
  }]);

  return ListFormatPonyFill;
}();

var ListFormat = typeof Intl !== 'undefined' && Intl.ListFormat || ListFormatPonyFill;
var partsTable = [['years', 'year'], ['months', 'month'], ['weeks', 'week'], ['days', 'day'], ['hours', 'hour'], ['minutes', 'minute'], ['seconds', 'second'], ['milliseconds', 'millisecond']];
var twoDigitFormatOptions = {
  minimumIntegerDigits: 2
};

var DurationFormat = /*#__PURE__*/function () {
  function DurationFormat(locale) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DurationFormat);

    _DurationFormat_options.set(this, void 0);

    var style = String(options.style || 'short');
    if (style !== 'long' && style !== 'short' && style !== 'narrow' && style !== 'digital') style = 'short';
    var prevStyle = style === 'digital' ? 'numeric' : style;
    var hours = options.hours || prevStyle;
    prevStyle = hours === '2-digit' ? 'numeric' : hours;
    var minutes = options.minutes || prevStyle;
    prevStyle = minutes === '2-digit' ? 'numeric' : minutes;
    var seconds = options.seconds || prevStyle;
    prevStyle = seconds === '2-digit' ? 'numeric' : seconds;
    var milliseconds = options.milliseconds || prevStyle;

    __classPrivateFieldSet(this, _DurationFormat_options, {
      locale: locale,
      style: style,
      years: options.years || style === 'digital' ? 'short' : style,
      yearsDisplay: options.yearsDisplay === 'always' ? 'always' : 'auto',
      months: options.months || style === 'digital' ? 'short' : style,
      monthsDisplay: options.monthsDisplay === 'always' ? 'always' : 'auto',
      weeks: options.weeks || style === 'digital' ? 'short' : style,
      weeksDisplay: options.weeksDisplay === 'always' ? 'always' : 'auto',
      days: options.days || style === 'digital' ? 'short' : style,
      daysDisplay: options.daysDisplay === 'always' ? 'always' : 'auto',
      hours: hours,
      hoursDisplay: options.hoursDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
      minutes: minutes,
      minutesDisplay: options.minutesDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
      seconds: seconds,
      secondsDisplay: options.secondsDisplay === 'always' ? 'always' : style === 'digital' ? 'always' : 'auto',
      milliseconds: milliseconds,
      millisecondsDisplay: options.millisecondsDisplay === 'always' ? 'always' : 'auto'
    }, "f");
  }

  _createClass(DurationFormat, [{
    key: "resolvedOptions",
    value: function resolvedOptions() {
      return __classPrivateFieldGet(this, _DurationFormat_options, "f");
    }
  }, {
    key: "formatToParts",
    value: function formatToParts(duration) {
      var list = [];

      var options = __classPrivateFieldGet(this, _DurationFormat_options, "f");

      var style = options.style;
      var locale = options.locale;

      var _iterator2 = _createForOfIteratorHelper(partsTable),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
              unit = _step2$value[0],
              nfUnit = _step2$value[1];

          var value = duration[unit];
          if (options["".concat(unit, "Display")] === 'auto' && !value) continue;
          var unitStyle = options[unit];
          var nfOpts = unitStyle === '2-digit' ? twoDigitFormatOptions : unitStyle === 'numeric' ? {} : {
            style: 'unit',
            unit: nfUnit,
            unitDisplay: unitStyle
          };
          list.push(new Intl.NumberFormat(locale, nfOpts).format(value));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return new ListFormat(locale, {
        type: 'unit',
        style: style === 'digital' ? 'short' : style
      }).formatToParts(list);
    }
  }, {
    key: "format",
    value: function format(duration) {
      return this.formatToParts(duration).map(function (p) {
        return p.value;
      }).join('');
    }
  }]);

  return DurationFormat;
}();

export { DurationFormat as default };
_DurationFormat_options = new WeakMap();